import { SxProps, Theme } from "@mui/material";

export const imageBanner: SxProps<Theme> = {
    width: "100%",
    height: "auto",
    objectFit: "cover",
    my: 6,
    borderTop: (theme: Theme) => `4px solid ${theme.palette.white}`,
    borderBottom: (theme: Theme) => `4px solid ${theme.palette.white}`,
};
